"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSetBase = exports.WalletStatus = void 0;
const mobx_1 = require("mobx");
const common_1 = require("@keplr-wallet/common");
const launchpad_1 = require("@cosmjs/launchpad");
const cosmos_1 = require("@keplr-wallet/cosmos");
const axios_1 = __importDefault(require("axios"));
const buffer_1 = require("buffer/");
const long_1 = __importDefault(require("long"));
var SignMode = cosmos_1.cosmos.tx.signing.v1beta1.SignMode;
const ethermint_address_converter_1 = require("@hanchon/ethermint-address-converter");
var WalletStatus;
(function (WalletStatus) {
    WalletStatus["NotInit"] = "NotInit";
    WalletStatus["Loading"] = "Loading";
    WalletStatus["Loaded"] = "Loaded";
    WalletStatus["NotExist"] = "NotExist";
    WalletStatus["Rejected"] = "Rejected";
})(WalletStatus = exports.WalletStatus || (exports.WalletStatus = {}));
class AccountSetBase {
    constructor(eventListener, chainGetter, chainId, queriesStore, opts) {
        this.eventListener = eventListener;
        this.chainGetter = chainGetter;
        this.chainId = chainId;
        this.queriesStore = queriesStore;
        this.opts = opts;
        this._walletVersion = undefined;
        this._walletStatus = WalletStatus.NotInit;
        this._name = "";
        this._bech32Address = "";
        this._isSendingMsg = false;
        this.broadcastMode = "sync";
        this.hasInited = false;
        this.sendTokenFns = [];
        this.handleInit = () => this.init();
        mobx_1.makeObservable(this);
        this.pubKey = new Uint8Array();
        if (opts.autoInit) {
            this.init();
        }
    }
    getKeplr() {
        return this.opts.getKeplr();
    }
    get msgOpts() {
        return this.opts.msgOpts;
    }
    registerSendTokenFn(fn) {
        this.sendTokenFns.push(fn);
    }
    enable(keplr, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = this.chainGetter.getChain(chainId);
            if (this.opts.suggestChain) {
                if (this.opts.suggestChainFn) {
                    yield this.opts.suggestChainFn(keplr, chainInfo);
                }
                else {
                    yield this.suggestChain(keplr, chainInfo);
                }
            }
            yield keplr.enable(chainId);
        });
    }
    suggestChain(keplr, chainInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            yield keplr.experimentalSuggestChain(chainInfo.raw);
        });
    }
    *init() {
        // If wallet status is not exist, there is no need to try to init because it always fails.
        if (this.walletStatus === WalletStatus.NotExist) {
            return;
        }
        // If the store has never been initialized, add the event listener.
        if (!this.hasInited) {
            // If key store in the keplr extension is changed, this event will be dispatched.
            this.eventListener.addEventListener("keplr_keystorechange", this.handleInit);
        }
        this.hasInited = true;
        // Set wallet status as loading whenever try to init.
        this._walletStatus = WalletStatus.Loading;
        const keplr = yield* common_1.toGenerator(this.getKeplr());
        if (!keplr) {
            this._walletStatus = WalletStatus.NotExist;
            return;
        }
        this._walletVersion = keplr.version;
        try {
            yield this.enable(keplr, this.chainId);
        }
        catch (e) {
            console.log(e);
            this._walletStatus = WalletStatus.Rejected;
            this._rejectionReason = e;
            return;
        }
        try {
            const key = yield* common_1.toGenerator(keplr.getKey(this.chainId));
            this._bech32Address = key.bech32Address;
            this._name = key.name;
            this.pubKey = key.pubKey;
            // Set the wallet status as loaded after getting all necessary infos.
            this._walletStatus = WalletStatus.Loaded;
        }
        catch (e) {
            console.log(e);
            // Caught error loading key
            // Reset properties, and set status to Rejected
            this._bech32Address = "";
            this._name = "";
            this.pubKey = new Uint8Array(0);
            this._walletStatus = WalletStatus.Rejected;
            this._rejectionReason = e;
        }
        if (this._walletStatus !== WalletStatus.Rejected) {
            // Reset previous rejection error message
            this._rejectionReason = undefined;
        }
    }
    disconnect() {
        this._walletStatus = WalletStatus.NotInit;
        this.hasInited = false;
        this.eventListener.removeEventListener("keplr_keystorechange", this.handleInit);
        this._bech32Address = "";
        this._name = "";
        this.pubKey = new Uint8Array(0);
    }
    get walletVersion() {
        return this._walletVersion;
    }
    get isReadyToSendMsgs() {
        return (this.walletStatus === WalletStatus.Loaded && this.bech32Address !== "");
    }
    sendMsgs(type, msgs, memo = "", fee, signOptions, onTxEvents) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            mobx_1.runInAction(() => {
                this._isSendingMsg = type;
            });
            let txHash;
            let signDoc;
            try {
                if (typeof msgs === "function") {
                    msgs = yield msgs();
                }
                const result = yield this.broadcastMsgs(msgs, fee, memo, signOptions, this.broadcastMode);
                txHash = result.txHash;
                signDoc = result.signDoc;
            }
            catch (e) {
                mobx_1.runInAction(() => {
                    this._isSendingMsg = false;
                });
                if ((_a = this.opts.preTxEvents) === null || _a === void 0 ? void 0 : _a.onBroadcastFailed) {
                    this.opts.preTxEvents.onBroadcastFailed(e);
                }
                if (onTxEvents &&
                    "onBroadcastFailed" in onTxEvents &&
                    onTxEvents.onBroadcastFailed) {
                    onTxEvents.onBroadcastFailed(e);
                }
                throw e;
            }
            let onBroadcasted;
            let onFulfill;
            if (onTxEvents) {
                if (typeof onTxEvents === "function") {
                    onFulfill = onTxEvents;
                }
                else {
                    onBroadcasted = onTxEvents.onBroadcasted;
                    onFulfill = onTxEvents.onFulfill;
                }
            }
            if ((_b = this.opts.preTxEvents) === null || _b === void 0 ? void 0 : _b.onBroadcasted) {
                this.opts.preTxEvents.onBroadcasted(txHash);
            }
            if (onBroadcasted) {
                onBroadcasted(txHash);
            }
            const txTracer = new cosmos_1.TendermintTxTracer(this.chainGetter.getChain(this.chainId).rpc, "/websocket", {
                wsObject: this.opts.wsObject,
            });
            txTracer.traceTx(txHash).then((tx) => {
                var _a;
                txTracer.close();
                mobx_1.runInAction(() => {
                    this._isSendingMsg = false;
                });
                // After sending tx, the balances is probably changed due to the fee.
                for (const feeAmount of signDoc.fee.amount) {
                    const bal = this.queries.queryBalances
                        .getQueryBech32Address(this.bech32Address)
                        .balances.find((bal) => bal.currency.coinMinimalDenom === feeAmount.denom);
                    if (bal) {
                        bal.fetch();
                    }
                }
                // Always add the tx hash data.
                if (tx && !tx.hash) {
                    tx.hash = buffer_1.Buffer.from(txHash).toString("hex");
                }
                if ((_a = this.opts.preTxEvents) === null || _a === void 0 ? void 0 : _a.onFulfill) {
                    this.opts.preTxEvents.onFulfill(tx);
                }
                if (onFulfill) {
                    onFulfill(tx);
                }
            });
        });
    }
    sendToken(amount, currency, recipient, memo = "", stdFee = {}, signOptions, onTxEvents) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.sendTokenFns.length; i++) {
                const fn = this.sendTokenFns[i];
                if (yield fn(amount, currency, recipient, memo, stdFee, signOptions, onTxEvents)) {
                    return;
                }
            }
            const denomHelper = new common_1.DenomHelper(currency.coinMinimalDenom);
            throw new Error(`Unsupported type of currency (${denomHelper.type})`);
        });
    }
    // Return the tx hash.
    broadcastMsgs(msgs, fee, memo = "", signOptions, mode = "async") {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.walletStatus !== WalletStatus.Loaded) {
                throw new Error(`Wallet is not loaded: ${this.walletStatus}`);
            }
            let aminoMsgs;
            let protoMsgs;
            if ("aminoMsgs" in msgs) {
                aminoMsgs = msgs.aminoMsgs;
                protoMsgs = msgs.protoMsgs;
            }
            else {
                aminoMsgs = msgs;
            }
            if (aminoMsgs.length === 0) {
                throw new Error("There is no msg to send");
            }
            if (this.hasNoLegacyStdFeature() &&
                (!protoMsgs || protoMsgs.length === 0)) {
                throw new Error("Chain can't send legecy stdTx. But, proto any type msgs are not provided");
            }
            const account = yield cosmos_1.BaseAccount.fetchFromRest(this.instance, this.bech32Address, true);
            const coinType = this.chainGetter.getChain(this.chainId).bip44.coinType;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const keplr = (yield this.getKeplr());
            const signDoc = launchpad_1.makeSignDoc(aminoMsgs, fee, this.chainId, memo, account.getAccountNumber().toString(), account.getSequence().toString());
            const signResponse = yield keplr.signAmino(this.chainId, this.bech32Address, signDoc, signOptions);
            const signedTx = this.hasNoLegacyStdFeature()
                ? cosmos_1.cosmos.tx.v1beta1.TxRaw.encode({
                    bodyBytes: cosmos_1.cosmos.tx.v1beta1.TxBody.encode({
                        messages: protoMsgs,
                        memo: signResponse.signed.memo,
                    }).finish(),
                    authInfoBytes: cosmos_1.cosmos.tx.v1beta1.AuthInfo.encode({
                        signerInfos: [
                            {
                                publicKey: {
                                    type_url: coinType === 60
                                        ? "/ethermint.crypto.v1.ethsecp256k1.PubKey"
                                        : "/cosmos.crypto.secp256k1.PubKey",
                                    value: cosmos_1.cosmos.crypto.secp256k1.PubKey.encode({
                                        key: buffer_1.Buffer.from(signResponse.signature.pub_key.value, "base64"),
                                    }).finish(),
                                },
                                modeInfo: {
                                    single: {
                                        mode: SignMode.SIGN_MODE_LEGACY_AMINO_JSON,
                                    },
                                },
                                sequence: long_1.default.fromString(signResponse.signed.sequence),
                            },
                        ],
                        fee: {
                            amount: signResponse.signed.fee.amount,
                            gasLimit: long_1.default.fromString(signResponse.signed.fee.gas),
                        },
                    }).finish(),
                    signatures: [buffer_1.Buffer.from(signResponse.signature.signature, "base64")],
                }).finish()
                : launchpad_1.makeStdTx(signResponse.signed, signResponse.signature);
            return {
                txHash: yield keplr.sendTx(this.chainId, signedTx, mode),
                signDoc: signResponse.signed,
            };
        });
    }
    get instance() {
        const chainInfo = this.chainGetter.getChain(this.chainId);
        return axios_1.default.create(Object.assign({
            baseURL: chainInfo.rest,
        }, chainInfo.restConfig));
    }
    get walletStatus() {
        return this._walletStatus;
    }
    get rejectionReason() {
        return this._rejectionReason;
    }
    get name() {
        return this._name;
    }
    get bech32Address() {
        return this._bech32Address;
    }
    get isSendingMsg() {
        return this._isSendingMsg;
    }
    get hasEvmosHexAddress() {
        return this.bech32Address.startsWith("evmos");
    }
    get evmosHexAddress() {
        return ethermint_address_converter_1.evmosToEth(this.bech32Address);
    }
    get queries() {
        return this.queriesStore.get(this.chainId);
    }
    hasNoLegacyStdFeature() {
        const chainInfo = this.chainGetter.getChain(this.chainId);
        return (chainInfo.features != null &&
            chainInfo.features.includes("no-legacy-stdTx"));
    }
}
__decorate([
    mobx_1.observable
], AccountSetBase.prototype, "_walletVersion", void 0);
__decorate([
    mobx_1.observable
], AccountSetBase.prototype, "_walletStatus", void 0);
__decorate([
    mobx_1.observable
], AccountSetBase.prototype, "_rejectionReason", void 0);
__decorate([
    mobx_1.observable
], AccountSetBase.prototype, "_name", void 0);
__decorate([
    mobx_1.observable
], AccountSetBase.prototype, "_bech32Address", void 0);
__decorate([
    mobx_1.observable
], AccountSetBase.prototype, "_isSendingMsg", void 0);
__decorate([
    mobx_1.flow
], AccountSetBase.prototype, "init", null);
__decorate([
    mobx_1.action
], AccountSetBase.prototype, "disconnect", null);
__decorate([
    mobx_1.computed
], AccountSetBase.prototype, "isReadyToSendMsgs", null);
exports.AccountSetBase = AccountSetBase;
//# sourceMappingURL=base.js.map